import { safeJoin } from './string-utils.ts';

export const getFullName = (firstName: string | null | undefined, lastName: string | null | undefined) => {
    return safeJoin([firstName, lastName], ' ');
};
